import { inject, provide, reactive, computed, watch, ref, ComputedRef } from "vue"
import { getMenus } from './menus'
import { router, onBeforeEach } from '@scripts/router/router'
import Store from '@scripts/store/store'

export default class MainContext {
  data = reactive({
    menuIsCollapse: false,
    selectedKeys: ['/store']
  })
  
  menus: ComputedRef<SystemMenu[]>;
  tagStore = Store.useTab()
  constructor() { 
    // 根据商户类型获取菜单
    this.menus = computed(() => getMenus($app.store?.storeType))
  }

  init() {
    router.beforeEach(onBeforeEach)
    this.data.selectedKeys = [$router.currentRoute.value.fullPath]    // 当前选中的菜单
    // 页面第一次加载时，重新定位路由，根据当前浏览器的地址，加载对应的视图
    router.push({ path: '/redirect', query: { key: $router.currentRoute.value.fullPath } })
    watch(() => this.tagStore.activeKey, () => {
      this.data.selectedKeys = [this.tagStore.activeKey]
    })
  }

  provide() {
    provide("mainContext", this)
  }
  static inject() {
    return inject('mainContext') as MainContext
  }
}

